import { useEffect, useState } from 'react';
import { LASSTATUS_HANDELSE, lasStatus } from '../utils/lasstatus';

/** Läsläget per instruktion, uppdateras när något markeras som läst. */
export function useLasstatus() {
  const [status, setStatus] = useState(lasStatus);
  useEffect(() => {
    const uppdatera = () => setStatus(lasStatus());
    window.addEventListener(LASSTATUS_HANDELSE, uppdatera);
    window.addEventListener('storage', uppdatera);
    return () => {
      window.removeEventListener(LASSTATUS_HANDELSE, uppdatera);
      window.removeEventListener('storage', uppdatera);
    };
  }, []);
  return status;
}
